import type { CamelCasedPropertiesDeep } from 'type-fest';
import { capitalize } from '../string';
import { convertKeysToCase } from './keys-string-case-conversion';

export const toCamelCase = (str: string | number = ''): string => {
  const words = str.toString().match(/[A-Z]?[a-z]+|[A-Z]+(?![a-z])|\d+/g) || [str];

  return words
    .map((word, index) => {
      const lowerCaseWord = word.toString().toLowerCase();
      return index ? capitalize(lowerCaseWord) : lowerCaseWord;
    })
    .join('');
};

export const keysToCamelCase = <T>(obj: T, deep = false): CamelCasedPropertiesDeep<T> =>
  convertKeysToCase<T, CamelCasedPropertiesDeep<T>>({ obj, convertFn: toCamelCase, deep });
